import { waitDialog } from 'dialogs';
import { MobxQuery } from 'mobx/MobxQuery';
import { previewOpenPeriods } from 'api/scheduling_windows/operations/previewOpenPeriods';

import { OpenPeriodsPreview } from './OpenPeriodsPreview';

/**
 * Show when a saved scheduling window is open, from now on.
 *
 * The query's parameters are just the window id, and it is opened on one window, so
 * they never change — the evaluation happens once, when the dialog mounts and starts
 * observing the value, and `refresh()` re-asks. That is the right shape here rather
 * than a limitation: the answer depends on the clock, not on any parameter, so no
 * comparison of inputs could tell it had gone out of date.
 *
 * `debounceMs: 0` because nothing here is keystroke-driven.
 */
export const showOpenPeriodsPreview = (id: number): Promise<void> => {
  const query = new MobxQuery({
    params: () => id,
    fetch: previewOpenPeriods,
    debounceMs: 0,
  });

  return waitDialog<void>((ok) => <OpenPeriodsPreview query={query} onHide={ok} />).finally(query.dispose);
};
